import * as React from 'react';
export default function SvgFaceSad() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.627 15.99a.75.75 0 0 1-.617-.863l.74.123c-.74-.123-.74-.125-.74-.125v-.002l.002-.005.002-.011a1.457 1.457 0 0 1 .025-.111 2.616 2.616 0 0 1 .51-.976C10.008 13.47 10.784 13 12 13s1.992.47 2.451 1.02a2.616 2.616 0 0 1 .51.976 1.7 1.7 0 0 1 .02.082l.003.018.002.011.002.011.001.005v.003l-.739.124.74-.123a.75.75 0 0 1-1.478.26l-.002-.011v-.003l.738-.123-.646.108a3.42 3.42 0 0 0-.092.015v.003a1.12 1.12 0 0 0-.211-.396c-.166-.2-.515-.48-1.299-.48-.784 0-1.133.28-1.299.48a1.12 1.12 0 0 0-.214.408v-.004l.002-.004a.75.75 0 0 1-.862.61ZM10 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8 6.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z",
    fill: "currentColor"
  }));
}